export const FILTERS = [
	{
		label: 'ทั้งหมด',
		isActive: false,
	},
	{
		label: 'สินค้าที่ผลิต',
		isActive: false,
	},
	{
		label: 'ประเภทงานพิมพ์',
		isActive: false,
	},
	{
		label: 'Sustainability',
		isActive: false,
	},
	{
		label: 'Certificates',
		isActive: false,
	},
]
